import { EventType } from '@azure/msal-browser';

export type EmptyEventHandler = () => void;
export type DefaultEventHandler = (eventType: EventType, payload: any) => void;
export type EventHandlers<T> = Partial<Record<keyof typeof EventType, T>> & {
  DEFAULT: T;
};
export const handleEvents = async (eventType: EventType, eventHandlers: EventHandlers<() => void>) => {
  switch (eventType) {
    case EventType.LOGIN_SUCCESS:
      eventHandlers.LOGIN_SUCCESS?.();
      break;

    case EventType.ACQUIRE_TOKEN_SUCCESS:
      eventHandlers.ACQUIRE_TOKEN_SUCCESS?.();
      break;

    case EventType.SSO_SILENT_SUCCESS:
      eventHandlers.SSO_SILENT_SUCCESS?.();
      break;

    case EventType.ACQUIRE_TOKEN_FAILURE:
      eventHandlers.ACQUIRE_TOKEN_FAILURE?.();
      break;

    case EventType.ACQUIRE_TOKEN_BY_CODE_FAILURE:
      eventHandlers.ACQUIRE_TOKEN_BY_CODE_FAILURE?.();
      break;

    case EventType.SSO_SILENT_FAILURE:
      eventHandlers.SSO_SILENT_FAILURE?.();
      break;

    case EventType.LOGIN_FAILURE:
      eventHandlers.LOGIN_FAILURE?.();
      break;

    default:
      eventHandlers.DEFAULT?.();
      break;
  }
};
